const setEntityMetadata = async ({
    worldContract,
    smartObjectId,
    newName,
    newDappUrl,
    newDescription
  }: {
    worldContract: any;
    smartObjectId: string;
    newName: string;
    newDappUrl: string;
    newDescription: string;
  }): Promise<string | undefined> => {
    let txHash;
  
    txHash = await worldContract.write.eveworld__setEntityMetadata([smartObjectId, newName, newDappUrl, newDescription]);

    return txHash;
  };
  
  export default setEntityMetadata;
  